/* eslint-disable */

// import $ from 'jquery'
// jQuery is always injected by basic.bundle due to provide back compatibility
// with external plugins loaded plugins on page.
const { $ } = window;

// switch between using WebAPI (true) or WebMethod (false)

export const handleEventAlert = (
  idS,
  root,
  onDone,
  onEventNotFound = () => {}
) => {
  const url = root + "/eMAR/eMAR_Tree.aspx/callDB";
  $.ajax({
    type: "POST",
    url: url,
    data: "{'id': '" + idS + "', reload: '0'}",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    async: true,
    cache: false,
  })
    .done(function (json, textStatus, jqXHR) {
      //console.timeEnd("$.ajax");
      // mkLog("$.ajax END textStatus:", textStatus, ", json:", json);
      // mkLog("jqXHR", jqXHR);
      if (textStatus === "success") {
        // mkLog("success");
        // mkLog("=======");
        if (json != null && json.d != null) {
          const buttons = json.d.hideAcknowledged
            ? {
                HOLD: {
                  label: "Hold for later",
                  type: "info",
                  callback: () => {
                    return false;
                  },
                },
              }
            : {
                ACK: {
                  label: "Acknowledged",
                  type: "success",
                  focus: true,
                  callback: () => {
                    return true;
                  },
                },
                HOLD: {
                  label: "Hold for later",
                  type: "info",
                  callback: () => {
                    return false;
                  },
                },
              };

          DialogManager.GlobalDialog.show({
            title: "Event Alert",
            body: json.d.html,
            width: 700,
            buttons,
          }).then((r) => {
            const success = function (result) {
              if (result.d.html !== "Ok") {
                alert(result.d.html);
              }
              onDone();
            };

            if (r === undefined) {
              $.post({
                url: root + "eMAR/eMAR_Tree.aspx/callDBEventAudit",
                data: JSON.stringify({
                  id: json.d.id,
                  reload: json.d.reload,
                  audit: "Close",
                }),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
              }).done(success);
            } else if (r === true) {
              $.post({
                url: root + "eMAR/eMAR_Tree.aspx/callDBSaveEvent",
                data: JSON.stringify({ id: json.d.id, reload: json.d.reload }),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
              }).done(success);
            } else if (r === false) {
              $.post({
                url: root + "eMAR/eMAR_Tree.aspx/callDBEventAudit",
                data: JSON.stringify({
                  id: json.d.id,
                  reload: json.d.reload,
                  audit: "Hold for Later",
                }),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
              }).done(success);
            }
            console.debug("Return value:", r);
          });
          return;
        } else {
          onDone();
        }
      } else {
        onDone();
        // mkLog("Not able to retrive data\r\n\r\nReason: " + textStatus);
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      if (jqXHR.status === 404 || jqXHR.status === 403) {
        onEventNotFound();
      } else {
        //console.timeEnd("$.ajax");
        AjaxFailed(jqXHR);
        // mkLog(textStatus+":", errorThrown, jqXHR);
      }
      onDone();
    });
};

function AjaxFailed(result) {
  try {
    var jsonRet = result.responseText;
    if (jsonRet != null) {
      var ex = eval("(" + jsonRet + ")");
      if (ex && ex.Message && ex.StackTrace) {
        var stack = ex.StackTrace.toString();
        if (stack.indexOf("\\") > 0) {
          stack = stack.toString().substring(stack.lastIndexOf("\\") + 1);
        }
        //alert('Error when processing request.\r\n\r\nTechnical information: ' + ex.Message + '\r\n(at ' + stack + ')');
        console.error(
          "Error when processing request.\r\n\r\nTechnical information: " +
            ex.Message +
            "\r\n(at " +
            stack +
            ")"
        );
      } else {
        //alert(result.status + ' ' + result.statusText);
        console.error(result.status + " " + result.statusText);
      }

      if (result.status === 400 && ex.Message === "Invalid sessionID") {
        window.RootAPI.Navigation.logout();
      }
    } else {
      // alert(result.status + ' ' + result.statusText);
      console.error(result.status + " " + result.statusText);
    }
  } catch (err) {
    // alert("Ajax Failed...");
    console.error("Ajax Failed...", err);
  }

  // if ajaxCall crashes then reload the menu
  // If the API is constantly failing, then this will be locking the app forever.
  window.location.reload();
}

export {};
